class OptionButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();
    if (this.dataset.isDefault == "true") return;
    switch (this.dataset.option) {
      case "variant":
        publish(PUB_SUB_EVENTS.variantChange, {
          option_id: this.dataset.optionId,
          option_label: this.dataset.optionName,
          option_handle: this.dataset.optionValue,
        });
        break;

      case "sorting":
        publish(PUB_SUB_EVENTS.sortingChange, {
          option_id: this.dataset.optionId,
          option_label: this.dataset.optionName,
          option_value: this.dataset.optionValue,
          option_default: this.dataset.optionDefault,
        });
        break;

      default:
        break;
    }
  }
}
customElements.define("option-button", OptionButton);
